import { render, staticRenderFns } from "./LeadEvents.vue?vue&type=template&id=22ad67fd&scoped=true&"
import script from "./LeadEvents.vue?vue&type=script&lang=js&"
export * from "./LeadEvents.vue?vue&type=script&lang=js&"
import style0 from "./LeadEvents.vue?vue&type=style&index=0&id=22ad67fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ad67fd",
  null
  
)

export default component.exports